<template>
  <div :class="['app-container', { 'bdc-list-page': isBdc }]">
    <!-- 工具栏 -->
    <div class="filter-container" :class="{ 'bdc-filter-bar': isBdc }">
      <el-button class="filter-item" type="primary" size="small" icon="el-icon-circle-plus-outline" @click="handleAdd">添加角色</el-button>
      <el-input class="filter-item" size="small" v-model="search" clearable placeholder="名称模糊查询" style="width:200px;"></el-input>
      <el-select class="filter-item" v-model="quanxianleixingvalue" size="small" placeholder>
        <el-option label="全部类型" value></el-option>
        <el-option label="系统权限" value="0"></el-option>
        <el-option label="自定义权限" value="1"></el-option>
      </el-select>

      <!-- 表格header 筛选 -->
      <div class="filterTableHeader" style="float:right;" v-if="isAdmin_Vip && !isBdc">
        <el-popover width="400" trigger="click">
          <el-button slot="reference" size="small" icon="el-icon-s-grid" style="font-size: 16px;padding:5px 10px;" title="筛选列"><i class="el-icon-caret-bottom"></i></el-button>
          <el-checkbox-group class="checkbox-table-headers" v-model="checkboxTitle">
            <el-checkbox v-for="(item,index) in tableTheadOptions" :key="index" :label="item">{{item[Object.keys(item)[0]]}}</el-checkbox>
          </el-checkbox-group>
        </el-popover>
      </div>
    </div>

    <!-- 表格 -->
    <div ref="bdcTableArea" :class="{'bdc-table-area': isBdc}">
    <el-table class="grayTableTile" size="small" v-loading="listLoading" :data="tableList" border row-key="name" :tree-props="{children: 'childs', hasChildren: 'hasChildren'}" style="width: 100%" :height="tableHeightDaily" @sort-change="handleAgeSortChange">
      <el-table-column v-for="(item,index) in tableTheads" :key="index" :label="item[Object.keys(item)[0]]" :prop="Object.keys(item)[0]" sortable='custom' :min-width="Object.keys(item)[0] == 'id' ? '60px' :'120px'">
        <template slot-scope="scope">
          <span v-if="Object.keys(item)[0] == 'name'" style="color:#646cf5;cursor: pointer;" @click="juesexiangqing(scope.row)">{{ scope.row[Object.keys(item)[0]]}}</span>
          <span v-else-if="Object.keys(item)[0] == 'type'">{{ scope.row[Object.keys(item)[0]] | yinyongleixing }}</span>
          <span v-else>{{ scope.row[Object.keys(item)[0]]}}</span>
        </template>
      </el-table-column>

      <el-table-column label="操作" width="400">
        <template slot-scope="scope">
          <div class="bdc-table-op-cell">
            <el-button type="text" class="bdc-table-op-muted" @click="tianjiazizu(scope.row)">添加子角色</el-button>
            <el-button v-if="isAdmin_Vip || (!isAdmin_Vip && scope.row['type'] == 1)" type="text" class="bdc-table-op-muted" @click="bianjijuese(scope.row)">编辑</el-button>
            <el-button v-if="isAdmin_Vip || (!isAdmin_Vip && scope.row['type'] == 1)" type="text" class="bdc-table-op-danger" @click="shanchujuese(scope.row)">删除</el-button>
            <el-button v-if="isAdmin_Vip || (!isAdmin_Vip && scope.row['type'] == 1)" type="text" class="bdc-table-op-muted" @click="tianjiaquanxian(scope.row,'batch-purview')">添加权限</el-button>
          </div>
        </template>
      </el-table-column>

    </el-table>
    </div>

    <!-- 分页 -->
    <bdc-table-footer>
      <template v-if="isAdmin_Vip" #actions>
        <el-popover width="400" trigger="click">
          <bdc-column-filter-button slot="reference" />
          <el-checkbox-group class="checkbox-table-headers" v-model="checkboxTitle">
            <el-checkbox v-for="(item,index) in tableTheadOptions" :key="index" :label="item">{{item[Object.keys(item)[0]]}}</el-checkbox>
          </el-checkbox-group>
        </el-popover>
      </template>
      <pagination v-show="total>0" :auto-scroll="false" :background="!isBdc" :total="total" :page.sync="listQuery.pageNo" :limit.sync="listQuery.pageSize" :class="isBdc ? 'bdc-table-pagination' : ''" />
    </bdc-table-footer>

    <!-- 添加 编辑角色 -->
    <el-dialog :title="formType == 'add' ? '添加角色信息' : formType == 'edit' ? '编辑角色信息' : '添加子角色'" v-if="addjuese" :visible.sync="addjuese" width="500px">
      <el-form ref="form" :model="form" :rules="formRules" label-width="100px">
        <el-form-item label="角色名称：" prop="name" v-if="formType != 'addSon'">
          <el-input size="small" :disabled="formType == 'edit'" v-model="form.name" style="width:300px"></el-input>
        </el-form-item>

        <el-form-item label="显示名称：" prop="title">
          <el-input size="small" v-model="form.title" style="width:300px"></el-input>
        </el-form-item>

        <el-form-item label="备注：" prop="description">
          <el-input v-model="form.description" type="textarea" style="width:300px"></el-input>
        </el-form-item>

      </el-form>

      <!-- 按钮组 -->
      <div class="dialog-butn-box" style="margin-top: 20px">
        <el-button size="small" type="primary" @click="handleSave">确认</el-button>
        <el-button size="small" @click="addjuese=false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 用户详情 -->
    <roles-info ref="info" @handleAddRoles="tianjiaquanxian" @handleAddGroups="tianjiayonghu"></roles-info>

    <!--右侧抽屉 穿梭框 添加分组 -->
    <transfer v-if="drawer" ref="transfer" :title="drawertitle" @getTransferList="getTransferList" @handleSave="handleSaveDrawer"></transfer>

  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import BdcTableFooter from '@/components/BdcTableFooter'
import BdcColumnFilterButton from '@/components/BdcTableFooter/BdcColumnFilterButton'
import { rolelist, roledelete, rolemerge, permissionfilterHas, roledoAssignPermission, userdoAssignRole, userfilterHasByRole } from '@Sys~/api/sys'
import { arrSlice, sortKeys } from '@/filters'
import RolesInfo from './components/rolesInfo'
import Transfer from './components/transferCollapse'
import bdcListTableHeight from '@Sys~/utils/bdcListTableHeight'

// table Header
const defaultFormThead = [
  { name: '角色名称' },
  { title: '显示名称' },
  { id: 'ID' },
  { type: '策略类型' },
  { description: '备注' },
  { addTime: '创建时间' }
]

// table 默认 header
const defaultChecked = [
  { name: '角色名称' },
  { title: '显示名称' },
  { type: '策略类型' },
  { addTime: '创建时间' }
]

// 弹窗默认的数据内容
const defaultFrom = {
  name: '', // 角色名称
  title: '', // 显示名称
  description: "" // 备注
}

export default {
  mixins: [bdcListTableHeight],
  components: { Pagination, BdcTableFooter, BdcColumnFilterButton, Transfer, RolesInfo },
  data() {
    return {
      search: '',
      quanxianleixingvalue: '',
      isAdmin_Vip: this.$store.getters.roles.indexOf('admin') > -1 || this.$store.getters.roles.indexOf('vip') > -1,

      // 表格
      listLoading: false,
      originalCaseTable: [],// 排序原始数据
      caseTable: [], // 存放后端一次性返回的所有数据
      handCaseTable: [], // 存放处理假分页后的数据(等距切割)
      tableData: [], // 切割后页面应展示的数据
      tableTheadOptions: defaultFormThead,
      checkboxTitle: defaultFormThead.filter(item => !item.id && !item.description),
      tableTheads: defaultChecked,

      total: 0,
      listQuery: {
        pageNo: 1,
        pageSize: 10
      },

      // 创建 编辑角色 添加子角色
      formType: 'add',
      formRules: {
        name: [{ required: true, trigger: ['blur', 'change'], message: '请填写角色名称' }],
        title: [{ required: true, trigger: ['blur', 'change'], message: '请填写显示名称' }],

      },
      form: {},
      addjuese: false,

      // 右侧抽屉
      drawer: false,
      drawertitle: "",
      jueseinfo: {}

    }
  },
  watch: {
    // 筛选table header
    checkboxTitle(valArr) {
      this.tableTheads = this.tableTheadOptions.filter(i => JSON.stringify(valArr).indexOf(JSON.stringify(i)) > -1)
    }
  },
  computed: {
    isBdc() {
      return process.env.VUE_APP_PROJECT_TYPE === 'bdc'
    },
    // 筛选列表表
    tableList() {
      let caseTable = this.caseTable
      const search = this.search.toLowerCase().replace(/\s+/g, "");
      if (search || this.quanxianleixingvalue) {
        caseTable = this.caseTable.filter(data => {
          return (String(data['id']).toLowerCase().indexOf(search) > -1 || String(data['name']).toLowerCase().indexOf(search) > -1 || String(data['title']).toLowerCase().indexOf(search) > -1) && String(data['type']).toLowerCase().indexOf(this.quanxianleixingvalue) > -1
        })
      }

      this.total = caseTable.length
      // 将一维数组切割成二维数组
      this.handCaseTable = arrSlice(caseTable, this.listQuery.pageSize)
      this.tableData = this.handCaseTable[this.listQuery.pageNo - 1]
      return this.tableData
    }
  },

  filters: {
    yinyongleixing(value) {
      if (value == "0") {
        return "系统权限";
      } else if (value == "1") {
        return "自定义权限";
      }
    }
  },

  created() {
    this.getList()
  },
  methods: {
    // 获取列表
    getList() {
      this.listLoading = true
      rolelist().then(response => {
        this.listLoading = false
        if (response.code == 1) {
          this.caseTable = response.data
          this.originalCaseTable = JSON.parse(JSON.stringify(this.caseTable))
        }
      })
    },

    // 监听排序变化
    handleAgeSortChange(e) {
      if (e.order) {
        const order = e.order == 'descending' ? false : true
        this.caseTable.sort(sortKeys(e.prop, order))
      } else {
        this.caseTable = JSON.parse(JSON.stringify(this.originalCaseTable))
      }
    },

    // 角色权限详情
    juesexiangqing(row) {
      this.$refs['info'].init(row)
    },

    // 添加角色
    handleAdd() {
      this.addjuese = true
      this.formType = 'add'
      this.form = JSON.parse(JSON.stringify(defaultFrom))
      this.$nextTick(() => {
        this.$refs['form'].clearValidate()
      })
    },

    // 编辑
    bianjijuese(row) {
      this.addjuese = true
      this.formType = 'edit'
      this.form = JSON.parse(JSON.stringify(row))
      this.$nextTick(() => {
        this.$refs['form'].clearValidate()
      })
    },

    // 添加子角色
    tianjiazizu(row) {
      this.addjuese = true
      this.formType = 'addSon'
      this.form = {
        title: "", //显示名称
        description: "", //备注
        pid: row.id
      }
      this.$nextTick(() => {
        this.$refs['form'].clearValidate()
      })
    },

    // 确认 添加或编辑权限
    handleSave() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          rolemerge(this.form).then(response => {
            if (response.code == 1) {
              this.$message({
                message: this.formType == 'add' ? "添加成功" : "编辑成功",
                type: "success"
              });
              this.getList();
              this.addjuese = false;
            }
          });
        }
      })
    },

    // 删除
    shanchujuese(row) {
      this.$confirm('确认删除角色： "' + row.title + '" 吗？').then(_ => {
        roledelete(row.id).then(response => {
          if (response.code == 1) {
            this.$message({
              message: "删除成功",
              type: "success"
            });
            this.getList();
          }
        });
      }).catch(_ => { });
    },

    // 添加添加权限
    tianjiaquanxian(row, specialSource) {
      this.drawer = true
      this.jueseinfo = row
      this.$nextTick(() => {
        this.drawertitle = "添加角色权限：" + row.title;

        this.$refs['transfer'].init("batch-purview", row, specialSource)

        if (process.env.VUE_APP_PROJECT_TYPE == 'ads') {
          if (specialSource == 'batch-purview') {
            this.$refs['transfer'].sourceList = [
              {
                title: '菜单', // Collapse 折叠面板 标题
                name: '1', // Collapse 折叠面板 序号
                checkStrictly: false, // 关联
                toSelectedList: { // 待选数据
                  title: '待选', // 待选标题
                  search: '',
                  disabledSearch: true,
                  treeload: true,
                  list: []
                },
                selectedList: { // 已选数据
                  title: '已选',
                  search: '',
                  disabledSearch: true,
                  treeload: false,
                  rawList: [],
                  list: []
                }
              },
              {
                title: '媒体', // Collapse 折叠面板 标题
                name: '2', // Collapse 折叠面板 序号
                checkStrictly: false, // 关联
                toSelectedList: { // 待选数据
                  title: '待选', // 待选标题
                  search: '',
                  disabledSearch: true,
                  treeload: true,
                  list: []
                },
                selectedList: { // 已选数据
                  title: '已选',
                  search: '',
                  disabledSearch: true,
                  treeload: false,
                  rawList: [],
                  list: []
                }
              },
              // {
              //     title: '监测', // Collapse 折叠面板 标题
              //     name: '3', // Collapse 折叠面板 序号
              //     checkStrictly: true, // true不关联 false不关联
              //     toSelectedList:{ // 待选数据
              //         title: '待选', // 待选标题
              //         search:'', 
              //         disabledSearch: true,
              //         treeload: true,
              //         list:[]
              //     },
              //     selectedList: { // 已选数据
              //         title: '已选',
              //         search:'',
              //         disabledSearch: true,
              //         treeload: false,
              //         rawList:[],
              //         list:[]
              //     }
              // },
              {
                title: '指标', // Collapse 折叠面板 标题
                name: '4', // Collapse 折叠面板 序号
                checkStrictly: false, // 关联
                toSelectedList: { // 待选数据
                  title: '待选', // 待选标题
                  search: '',
                  disabledSearch: true,
                  treeload: true,
                  list: []
                },
                selectedList: { // 已选数据
                  title: '已选',
                  search: '',
                  disabledSearch: true,
                  treeload: false,
                  rawList: [],
                  list: []
                }
              },
              {
                title: '用户来源', // Collapse 折叠面板 标题
                name: '5', // Collapse 折叠面板 序号
                checkStrictly: false, // 关联
                toSelectedList: { // 待选数据
                  title: '待选', // 待选标题
                  search: '',
                  disabledSearch: true,
                  treeload: true,
                  list: []
                },
                selectedList: { // 已选数据
                  title: '已选',
                  search: '',
                  disabledSearch: true,
                  treeload: false,
                  rawList: [],
                  list: []
                }
              },
            ]
          } else {
            this.$refs['transfer'].sourceList = [
              {
                title: '菜单', // Collapse 折叠面板 标题
                name: '1', // Collapse 折叠面板 序号
                checkStrictly: false, // 关联
                toSelectedList: { // 待选数据
                  title: '待选', // 待选标题
                  search: '',
                  disabledSearch: true,
                  treeload: true,
                  list: []
                },
                selectedList: { // 已选数据
                  title: '已选',
                  search: '',
                  disabledSearch: true,
                  treeload: false,
                  rawList: [],
                  list: []
                }
              },
              {
                title: '媒体', // Collapse 折叠面板 标题
                name: '2', // Collapse 折叠面板 序号
                checkStrictly: false, // 关联
                toSelectedList: { // 待选数据
                  title: '待选', // 待选标题
                  search: '',
                  disabledSearch: true,
                  treeload: true,
                  list: []
                },
                selectedList: { // 已选数据
                  title: '已选',
                  search: '',
                  disabledSearch: true,
                  treeload: false,
                  rawList: [],
                  list: []
                }
              },
              {
                title: '监测', // Collapse 折叠面板 标题
                name: '3', // Collapse 折叠面板 序号
                checkStrictly: true, // true不关联 false不关联
                types: 6,
                toSelectedList: { // 待选数据
                  title: '待选', // 待选标题
                  search: '',
                  disabledSearch: true,
                  treeload: true,
                  list: []
                },
                selectedList: { // 已选数据
                  title: '已选',
                  search: '',
                  disabledSearch: true,
                  treeload: false,
                  rawList: [],
                  list: []
                }
              },
              {
                title: '指标', // Collapse 折叠面板 标题
                name: '4', // Collapse 折叠面板 序号
                checkStrictly: false, // 关联
                toSelectedList: { // 待选数据
                  title: '待选', // 待选标题
                  search: '',
                  disabledSearch: true,
                  treeload: true,
                  list: []
                },
                selectedList: { // 已选数据
                  title: '已选',
                  search: '',
                  disabledSearch: true,
                  treeload: false,
                  rawList: [],
                  list: []
                }
              },
              {
                title: '用户来源', // Collapse 折叠面板 标题
                name: '5', // Collapse 折叠面板 序号
                checkStrictly: false, // 关联
                toSelectedList: { // 待选数据
                  title: '待选', // 待选标题
                  search: '',
                  disabledSearch: true,
                  treeload: true,
                  list: []
                },
                selectedList: { // 已选数据
                  title: '已选',
                  search: '',
                  disabledSearch: true,
                  treeload: false,
                  rawList: [],
                  list: []
                }
              },
            ]
          }
        } else if (process.env.VUE_APP_PROJECT_TYPE == 'file') {
          this.$refs['transfer'].sourceList = [
            {
              title: '菜单', // Collapse 折叠面板 标题
              name: '1', // Collapse 折叠面板 序号
              checkStrictly: false, // 关联
              toSelectedList: { // 待选数据
                title: '待选', // 待选标题
                search: '',
                disabledSearch: true,
                treeload: true,
                list: []
              },
              selectedList: { // 已选数据
                title: '已选',
                search: '',
                disabledSearch: true,
                treeload: false,
                rawList: [],
                list: []
              }
            },
            {
              title: '功能点', // Collapse 折叠面板 标题
              name: '2', // Collapse 折叠面板 序号
              checkStrictly: false, // 关联
              toSelectedList: { // 待选数据
                title: '待选', // 待选标题
                search: '',
                disabledSearch: true,
                treeload: true,
                list: []
              },
              selectedList: { // 已选数据
                title: '已选',
                search: '',
                disabledSearch: true,
                treeload: false,
                rawList: [],
                list: []
              }
            },
            {
              title: '部门', // Collapse 折叠面板 标题
              name: '3', // Collapse 折叠面板 序号
              checkStrictly: false, // 关联
              toSelectedList: { // 待选数据
                title: '待选', // 待选标题
                search: '',
                disabledSearch: true,
                treeload: true,
                list: []
              },
              selectedList: { // 已选数据
                title: '已选',
                search: '',
                disabledSearch: true,
                treeload: false,
                rawList: [],
                list: []
              }
            },
            {
              title: '外包商', // Collapse 折叠面板 标题
              name: '4', // Collapse 折叠面板 序号
              checkStrictly: false, // 关联
              toSelectedList: { // 待选数据
                title: '待选', // 待选标题
                search: '',
                disabledSearch: true,
                treeload: true,
                list: []
              },
              selectedList: { // 已选数据
                title: '已选',
                search: '',
                disabledSearch: true,
                treeload: false,
                rawList: [],
                list: []
              }
            }
          ]
        } else {
          this.$refs['transfer'].sourceList = [
            {
              title: '菜单', // Collapse 折叠面板 标题
              name: '1', // Collapse 折叠面板 序号
              checkStrictly: false, // 关联
              toSelectedList: { // 待选数据
                title: '待选', // 待选标题
                search: '',
                disabledSearch: true,
                treeload: true,
                list: []
              },
              selectedList: { // 已选数据
                title: '已选',
                search: '',
                disabledSearch: true,
                treeload: false,
                rawList: [],
                list: []
              }
            },
            {
              title: '渠道', // Collapse 折叠面板 标题
              name: '2', // Collapse 折叠面板 序号
              checkStrictly: true, // true 不关联 false关联
              toSelectedList: { // 待选数据
                title: '待选', // 待选标题
                search: '',
                disabledSearch: true,
                treeload: true,
                list: []
              },
              selectedList: { // 已选数据
                title: '已选',
                search: '',
                disabledSearch: true,
                treeload: false,
                rawList: [],
                list: []
              }
            },
            {
              title: '国家维度', // Collapse 折叠面板 标题
              name: '3', // Collapse 折叠面板 序号
              checkStrictly: true, // true 不关联 false关联
              toSelectedList: { // 待选数据
                title: '待选', // 待选标题
                search: '',
                disabledSearch: true,
                treeload: true,
                list: []
              },
              selectedList: { // 已选数据
                title: '已选',
                search: '',
                disabledSearch: true,
                treeload: false,
                rawList: [],
                list: []
              }
            }
          ]
        }
      })
    },

    // 添加用户
    tianjiayonghu(row) {
      this.drawer = true
      this.jueseinfo = row
      this.$nextTick(() => {
        this.drawertitle = "添加角色用户：" + row.title;

        this.$refs['transfer'].init("userGroup", row)

        this.$refs['transfer'].sourceList = [
          {
            title: '', // Collapse 折叠面板 标题
            name: '1', // Collapse 折叠面板 序号
            checkStrictly: true, // 不关联
            toSelectedList: { // 待选数据
              title: '待选', // 待选标题
              search: '',
              disabledSearch: true,
              treeload: true,
              list: []
            },
            selectedList: { // 已选数据
              title: '已选',
              search: '',
              disabledSearch: true,
              treeload: false,
              rawList: [],
              list: []
            }
          },
        ]
      })
    },

    // 权限筛选列表
    getTransferList(source, row, type, specialSource) {
      if (source == "batch-purview") { // batch-purview
        // 获取待选组列表 权限
        permissionfilterHas(row.id, type).then(response => {

          let index = null
          if (specialSource && specialSource == 'batch-purview') {
            index = type == 2 ? 0 : (type == 4 || type == 5 || type == 1) ? 1 : type == 7 ? 2 : type == 8 ? 3 : type == 9 ? 2 : type == 10 ? 3 : null
          } else {
            index = type == 2 ? 0 : (type == 4 || type == 5 || type == 1) ? 1 : type == 6 ? 2 : type == 7 ? 3 : type == 8 ? 4 : type == 9 ? 2 : type == 10 ? 3 : type == 12 ? 2 : null
          }
          this.$refs['transfer'].sourceList[index].toSelectedList.treeload = false
          if (response.code == 1) {
            if (response.data && response.data.length > 0) {
              this.$refs['transfer'].sourceList[index].toSelectedList.disabledSearch = false
            }

            // response.data.forEach(e => {
            //   e.childs = [];
            // })

            this.$refs['transfer'].sourceList[index].toSelectedList.list = this.$refs['transfer'].transformList(response.data)
          }

        });
      } else {
        // 获取待选组列表 用户
        userfilterHasByRole(row.id).then(response => {
          this.$refs['transfer'].sourceList[0].toSelectedList.treeload = false
          if (response.code == 1) {
            if (response.data.length > 0) {
              this.$refs['transfer'].sourceList[0].toSelectedList.disabledSearch = false
            }
            this.$refs['transfer'].sourceList[0].toSelectedList.list = this.$refs['transfer'].transformList(response.data)
          }
        });
      }
    },

    // 确定添加 分组，添加权限
    handleSaveDrawer(list, row, source) {
      // console.log(row)
      if (source == "userGroup") {
        let ids = []
        list[0].selectedList.list.forEach(item => {
          ids.push(item.id)
        })

        const data = {
          userId: ids,
          roleId: [row.id]
        }

        userdoAssignRole(data).then(response => {
          this.$refs['transfer'].butnLoading = false;
          if (response.code == 1) {
            this.$message({
              message: "保存成功",
              type: "success"
            });
            this.$refs['transfer'].drawer = false
            this.drawer = false
            if (this.$refs['info'].juesequanxianlist) {
              this.$refs['info'].getList(row)
            } else {
              this.getList()
            }
          }
        });
      } else {
        const data = []
        list.forEach((group, index) => {
          let ids = []
          group.selectedList.list.forEach(item => {
            ids.push(item.id)
          })

          data.push({
            permissionIds: ids,
            roleId: [row.id],
            type: index == 0 ? 2 : index == 1 ? (process.env.VUE_APP_PROJECT_TYPE == 'ads' ? 5 : process.env.VUE_APP_PROJECT_TYPE == 'file' ? 1 : 4) : index == 2 ? (process.env.VUE_APP_PROJECT_TYPE == 'file' ? 9 : process.env.VUE_APP_PROJECT_TYPE == 'ads' ? 6 : 12) : index == 3 ? (process.env.VUE_APP_PROJECT_TYPE == 'file' ? 10 : 7) : index == 4 ? 8 : null
          })
        })
        // console.log(data)
        roledoAssignPermission(data).then(response => {
          this.$refs['transfer'].butnLoading = false;
          if (response.code == 1) {
            this.$message({
              message: "保存成功",
              type: "success"
            });
            this.$refs['transfer'].drawer = false
            this.drawer = false
            if (this.$refs['info'].juesequanxianlist) {
              this.$refs['info'].getList(row)
            } else {
              this.getList()
            }
          }
        });
      }
    },

  }
}
</script>